import React, { useState } from 'react';
import { fontSize, styled } from '@mui/system';
import { Button, Box, Typography, TextField } from '@mui/material';
import FormErrors from '../../components/FormErrors';
import { requestPasswordReset } from '../../lib/allauth';
import BackgroundContainer from '../../components/BackgroundContainer';
import BaseHeader from '../../components/BaseHeader';
import BaseButton from '../../components/BaseButton';
import BaseTextField from '../../components/BaseTextField';
import BaseFormContainer from '../../components/BaseFormContainer';

const Subtitle = styled(Typography)({
  fontFamily: 'Playfair Display, serif',
  fontSize: '1.5rem',
  color: '#ffbfe1',
  textAlign: 'center',
  textShadow: '0px 2px 6px rgba(0, 0, 0, 0.5)',
  lineHeight: '1.4',
});

export default function RequestPasswordReset() {
  const [email, setEmail] = useState('');
  const [response, setResponse] = useState({ fetching: false, content: null });

  function submit() {
    setResponse({ ...response, fetching: true });
    requestPasswordReset(email)
      .then((content) => {
        setResponse((r) => {
          return { ...r, content };
        });
      })
      .catch((e) => {
        console.error(e);
        window.alert(e);
      })
      .then(() => {
        setResponse((r) => {
          return { ...r, fetching: false };
        });
      });
  }

  if (response.content?.status === 200) {
    return (
      <BackgroundContainer>
        <BaseFormContainer sx={{
    width: '100%',
    padding: { xs: 2, sm: 3 },
    boxSizing: 'border-box',
    marginBottom: '20px',}}>
        <BaseHeader sx={{
          fontSize: '4rem', // 🎯 Full size title
          '@media (max-width: 360px)': {
            fontSize: '3.8rem', // 🧠 Gentle scale-down on ultra-small screens
          },
          '@media (max-width: 320px)': {
            fontSize: '3rem', // 🔒 Last-resort fallback for smallest devices
            lineHeight: '1.1',
          },
          textAlign: 'center', // (optional) center if you want
        }}>Password Reset</BaseHeader>
        <Subtitle
          variant="body1"
          style={{
            color: 'rgba(237, 218, 241, 0.7)',
            marginBottom: '20px',
            textAlign: 'center',
            fontSize: '1.2rem',
      '@media (max-width: 400px)': {
        fontSize: '1.1rem',
      },
      '@media (max-width: 360px)': {
        fontSize: '1rem',
      },
      '@media (max-width: 320px)': {
        fontSize: '0.95rem',
      },
          }}
        >
          Password reset instructions have been sent to your email.
        </Subtitle>
        <BaseButton sx={{
    marginTop: '14px',
    fontSize: '1.1rem',
    '@media (max-width: 360px)': {
      fontSize: '1rem',
    },
    '@media (max-width: 320px)': {
      fontSize: '0.95rem',
    },
  }} onClick={() => window.location.replace('/account/login')}>
          Back to Login
        </BaseButton>
        </BaseFormContainer>
      </BackgroundContainer>
    );
  }

  return (
    <BackgroundContainer>
      <BaseFormContainer sx={{
    width: '100%',
    padding: { xs: 2, sm: 3 },
    boxSizing: 'border-box',
    marginBottom: '20px',}}>
      <BaseHeader sx={{
          fontSize: '4rem', // 🎯 Full size title
          '@media (max-width: 360px)': {
            fontSize: '3.8rem', // 🧠 Gentle scale-down on ultra-small screens
          },
          '@media (max-width: 320px)': {
            fontSize: '3rem', // 🔒 Last-resort fallback for smallest devices
            lineHeight: '1.1',
          },
          textAlign: 'center', // (optional) center if you want
        }} >Reset Password</BaseHeader>
      <Subtitle
        style={{
          color: 'rgba(237, 218, 241, 0.7)',
          marginBottom: '20px',
          textAlign: 'center',
          fontSize: '1.2rem',
    '@media (max-width: 400px)': {
      fontSize: '1.1rem',
    },
    '@media (max-width: 360px)': {
      fontSize: '1rem',
    },
    '@media (max-width: 320px)': {
      fontSize: '0.95rem',
    },
        }}
      >
        Enter your email to receive a password reset link.
      </Subtitle>
      <FormErrors errors={response.content?.errors} />
      <BaseTextField
        label="Email Address"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <FormErrors param="email" errors={response.content?.errors} />
      <Box display="flex" alignItems="center">
        <BaseButton sx={{
    marginTop: '14px',
    fontSize: '1.1rem',
    '@media (max-width: 360px)': {
      fontSize: '1rem',
    },
    '@media (max-width: 320px)': {
      fontSize: '0.95rem',
    },
  }} onClick={() => window.location.replace('/account/login')}>
          Back to Login
        </BaseButton>
        <BaseButton sx={{
    marginTop: '14px',
    fontSize: '1.1rem',
    '@media (max-width: 360px)': {
      fontSize: '1rem',
    },
    '@media (max-width: 320px)': {
      fontSize: '0.95rem',
    },
  }} disabled={response.fetching} onClick={submit}>
          Send Reset Link
        </BaseButton>
      </Box>
      </BaseFormContainer>
    </BackgroundContainer>
  );
}
